import React, {Fragment} from 'react';
import classNames from 'classnames';
import PropTypes from "prop-types";
import Button from "../form/Button";
import {isTrue} from "../../utils/other";

const zIndexCounter = [];

const sizes = {
    large: 'lg',
    medium: 'md',
    small: 'sm'
}

export const isOpened = (state) => {
    return state === 'on' || isTrue(state);
}

class Modal extends React.Component {

    static propTypes = {
        state: PropTypes.oneOf([true, false, "0", "1", 0, 1, "on", "off"]),
        timeout: PropTypes.number,
        disabled: PropTypes.bool,
        onClose: PropTypes.func,
        closeAble: PropTypes.bool,
        texts: PropTypes.any,
        buttons: PropTypes.any,
        theme: PropTypes.string,
        size: PropTypes.oneOf(["large", "medium", "small"]),
        header: PropTypes.any,
        body: PropTypes.any,
        footer: PropTypes.any,
    }

    constructor(props) {
        super(props);
        this.state = {
            state: isOpened(this.props.state)
        };
        if (isOpened(this.state.state)) {
            zIndexCounter.push(this);
        }
        if (this.props.timeout) {
            const {onCloseCb} = this.getButtons();
            this.autoclose && clearTimeout(this.autoclose);
            this.autoclose = setTimeout(() => {
                onCloseCb && onCloseCb();
            }, this.props.timeout);
        }
    }

    onCloseAction = (event) => {
        if ([27].indexOf(event.which) !== -1) {
            if (isOpened(this.state.state) || isOpened(this.props.state)) {
                let i = zIndexCounter.indexOf(this);
                if (i === zIndexCounter.length - 1) {
                    this.hide();
                }
            }
        }
    }

    componentDidMount() {
        let i = zIndexCounter.indexOf(this);
        if (i === -1) {
            zIndexCounter.push(this);
        }
        document.addEventListener("keydown", this.onCloseAction, false);
    }

    componentWillUnmount() {
        let i = zIndexCounter.indexOf(this);
        if (i !== -1) {
            zIndexCounter.splice(i, 1);
        }
        document.removeEventListener("keydown", this.onCloseAction, false);
    }

    componentDidUpdate(prevProps, prevState, prevContext) {
        let i = zIndexCounter.indexOf(this);

        if ((!isOpened(prevState.state) && isOpened(this.state.state)) || (!isOpened(prevProps.state) && isOpened(this.props.state))) {
            if (i !== -1) {
                zIndexCounter.splice(i, 1);
            }
            zIndexCounter.push(this);
        }
        if (!isOpened(this.state.state) && i !== -1) {
            zIndexCounter.splice(i, 1);
        }
        if (isOpened(this.state.state)) {
            let i = zIndexCounter.indexOf(this);
            if (i === zIndexCounter.length - 1) {
                document.body.addEventListener("keydown", this.onCloseAction);
            } else {
                document.body.removeEventListener("keydown", this.onCloseAction);
            }
        } else {
            document.body.removeEventListener("keydown", this.onCloseAction);
        }
        if (this.props.timeout) {
            const {onCloseCb} = this.getButtons();
            this.autoclose && clearTimeout(this.autoclose);
            this.autoclose = setTimeout(() => {
                onCloseCb && onCloseCb();
            }, this.props.timeout);
        }
        if (this.props.state !== prevProps.state && this.state.state !== isOpened(this.props.state)) {
            this.setState({state: isOpened(this.props.state)})
        }
    }

    bringToFront = () => {
        let i = zIndexCounter.indexOf(this);
        if (i !== -1) {
            zIndexCounter.splice(i, 1);
        }
        zIndexCounter.push(this);
    }

    show = () => {
        this.setState({
            state: true
        }, () => this.bringToFront());
    }

    focus = () => {
        this.setState({
            state: true
        }, () => {
            this.bringToFront();
            this.el.focus()
        });
    }

    hide = () => {
        if (!this.props.disabled) {
            const {onCloseCb} = this.getButtons();
            onCloseCb && onCloseCb();
        }
    }

    getButtons = () => {
        const closeActions = [];
        const onCloseCb = async () => {
            if (this.closing) return;
            this.closing = true;
            try {
                await closeActions.reduce(async (previousPromise, nextAsyncFunction) => {
                    await previousPromise;
                    await nextAsyncFunction();
                }, Promise.resolve());
            } catch (e) {
                console.log(e);
            }
            this.closing = false;
        };
        let buttontexts = {
            "OK": "OK",
            "CLOSE": "Bezárás",
            "YES": "Igen",
            "NO": "Nem",
            "CANCEL": "Mégsem"
        };
        if (this.props.texts) buttontexts = {...buttontexts, ...this.props.texts};
        let closeButton = false;
        const buttons = (this.props.buttons || []).map(
            (buttondata, idx) => {
                let buttontype = undefined;
                let text = undefined;
                let buttonClassNames = "";
                let attributes = {};
                let cb = () => {};
                if (typeof(buttondata) === 'object') {
                    text = buttondata.text || text;
                    attributes = buttondata.props || attributes;
                    attributes.color = attributes.color || "default";
                    cb = buttondata.onClick || cb;
                    if (buttondata.onClose && !attributes.disabled) {
                        closeActions.push(cb);
                    }
                    buttonClassNames = buttondata.className || buttonClassNames;
                } else {
                    attributes.color = "default";
                    buttontype = buttondata;
                    text = buttontexts[buttontype];
                    if (buttontype === "CLOSE" && !attributes.disabled) {
                        closeButton = true;
                    }
                }
                if (text !== undefined) {
                    return <Button
                        key={idx}
                        {...attributes}
                        className={buttonClassNames}
                        data-dismiss="modal"
                        onClick={() => cb && cb()}>{text}</Button>
                }
            }
        ).filter((button) => button !== undefined);
        if (this.props.closeAble !== false || closeButton) {
            const fn = this.props.closeAble;
            const onClose = this.props.onClose;
            closeActions.push(async () => {
                if (fn instanceof Function) {
                    if (closeActions.indexOf(fn) === -1) {
                        await fn();
                    }
                }
                if (closeActions.indexOf(onClose) === -1) {
                    onClose && await onClose();
                }

                let i = zIndexCounter.indexOf(this);
                if (i !== -1) {
                    zIndexCounter.splice(i, 1);
                }
                this.setState({
                    state: false
                });
            });
        }
        return {buttons, onCloseCb: closeActions.length ? onCloseCb : undefined};
    }

    deserialize = (children) => {
        if (Array.isArray(children)) {
            children = children.map((child, idx) => {
                if (child !== null && child !== undefined && child instanceof Object && child.type) {
                    return React.createElement(child.type, {...child.props, children: this.deserialize(child.props.children), key: idx});
                } else {
                    return child;
                }
            });
        } else if (children !== null && children !== undefined && children instanceof Object && children.type) {
            children = React.createElement(children.type, {...children.props, children: this.deserialize(children.props.children)});
        }
        return children;
    }

    render() {
        let zIndex = zIndexCounter.indexOf(this);
        const theme = this.props.theme || 'default';
        const display = this.state.state ? {display: 'block'} : {display: 'none'};
        const {buttons, onCloseCb} = this.getButtons();
        return <Fragment>
            <div
                className={classNames("modal modal-" + theme + " fade ", {"in show": this.state.state}, this.props.className)}
                style={{...display, zIndex: 10000 + zIndex}}
            >
                <div
                    ref={(el) => this.el = el}
                    tabIndex={0}
                    className={"modal-dialog modal-" + (this.props.size ? sizes[this.props.size] : "sm")}
                >
                    <div className="modal-content">
                        <div className="modal-header">
                            <h4 className="modal-title">
                                {this.props.header}{!this.props.header && <span>&nbsp;</span>}
                            </h4>
                            {onCloseCb && <button
                                type="button"
                                className="close"
                                data-dismiss="modal"
                                aria-label="Close"
                                onClick={() => onCloseCb()}
                            >
                                <span aria-hidden="true">&times;</span>
                            </button>}
                        </div>
                        {(this.props.body || this.props.children) ? <div className="modal-body">
                            {this.state.state && this.deserialize(this.props.body || this.props.children)}
                        </div> : null}
                        {(!!this.props.footer || !!buttons.length) && <div className="modal-footer">
                            <div className="center-block">
                                {this.props.footer}
                                {buttons}
                            </div>
                        </div>}
                    </div>
                </div>
            </div>
            {this.state.state && <div onClick={(e) => {onCloseCb && onCloseCb()}} className={classNames("modal-backdrop fade ", {"in show": this.state.state})} />}
        </Fragment>;
    }
}

export default Modal;